"use client"

import { HttpTypes } from "@medusajs/types"
import { useTranslate } from "@tolgee/react"
import { ProductCard } from "../ProductCard/ProductCard"

export const MeilisearchProductsCarouselContent = ({
  meiliProduct,
  apiProduct,
  locale,
  showProductCount,
  rows,
}: {
  meiliProduct: HttpTypes.StoreProduct[]
  apiProduct: HttpTypes.StoreProduct[]
  locale: string
  showProductCount: number
  rows: number
}) => {
  const { t } = useTranslate()

  // Only show hits that survived region/sales-channel filtering via Store API.
  const allowedIds = new Set(apiProduct.map((p) => String(p.id)))
  const displayProducts = (
    allowedIds.size
      ? meiliProduct.filter((hit) => allowedIds.has(String(hit.id)))
      : []
  ).slice(0, showProductCount)

  return (
    <div className="w-full">
      {!displayProducts.length ? (
        <div className="text-center w-full my-10">
          <h2 className="uppercase text-primary heading-lg">
            {t("algolia_products_carousel.no_results")}
          </h2>
          <p className="mt-4 text-lg">
            {t("algolia_products_carousel.no_results_message")}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {displayProducts.map((hit) => (
            <ProductCard
              locale={locale}
              key={hit.id}
              product={hit}
              api_product={apiProduct.find((p) => p.id === hit.id)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
